import { DateTime } from 'ts-luxon';

import { LicenseInfo } from '@shure/cloud/shared/models/devices';

import { DeviceLicenseInfoV2Fragment } from '../graphql/generated/cloud-sys-api';

import { mapLicenseStateFromSysApi } from './map-license-state';

export function mapLicenseInfoV2FromSysApi(licenseInfos: DeviceLicenseInfoV2Fragment[]): LicenseInfo[] {
	return licenseInfos.map((license) => ({
		count: license.count,
		expirationDate: license.expirationDate ? DateTime.fromISO(license.expirationDate) : undefined,
		featureName: license.featureName ?? undefined,
		perpetual: !!license.perpetual,
		state: mapLicenseStateFromSysApi(license.state)
	}));
}
